//scroll variable to track window's scroll
var lastScrollTop = 0;
var mobileW = 0;

//vanilla variables for resizing
var w = window,
  d = document,
  e = d.documentElement,
  g = d.getElementsByTagName("body")[0],
  windowWidth = w.innerWidth || e.clientWidth || g.clientWidth,
  windowHeight = w.innerHeight || e.clientHeight || g.clientHeight;

//header image to be window height on homepage
if (document.getElementsByClassName("img-slide").length > 0) {
  let headerImages = document.getElementsByClassName("img-slide");
  let headerImagesLength = headerImages.length;
  for (let i = 0; i < headerImagesLength; i++) {
    headerImages[i].style.height = windowHeight + 10 + "px";
  }
}
resizeWindow();

// Func = limiting Scope for this file
(function () {
  $(document).ready(function () {
    const tablesResp = document.querySelectorAll(".capacity-chart table");
    if (tablesResp.length) {
      tablesResp.forEach((tablei) => {
        var tableresponsive = document.createElement("div");
        tableresponsive.classList.add("tableHold");
        tablei.parentNode.insertBefore(tableresponsive, tablei);
        tableresponsive.append(tablei);
        const ths = tablei.querySelectorAll("tr:first-child > *");
        tablei.querySelectorAll("tr + tr").forEach((row) => {
          const tds = row.querySelectorAll("td");
          let i = 0;
          for (i; i < tds.length; i++) {
            tds[i].setAttribute("data-label", ths[i].textContent);
          }
        });
        const rowHeads = tablei.querySelectorAll("tr td:first-child");
        rowHeads.forEach((ele) => {
          ele.addEventListener("click", (ev) => {
            ele.closest("tr").classList.toggle("active");
          });
        });
      });
    }
  });

  window.onload = function () {
    resizeWindow();
    scrollW();
  };

  window.addEventListener("scroll", function () {
    scrollW();
  });
  window.addEventListener("resize", function () {
    resizeWindow();
  });

  //scroll down click
  if (document.getElementsByClassName("scroll-down").length > 0) {
    document
      .getElementsByClassName("scroll-down")[0]
      .addEventListener("click", function () {
        animateTo("intro");
      });
  }

  //Navigation mobile burger menu
  document.getElementById("burgerMenu").addEventListener("click", function () {
    if (!this.classList.contains("open")) {
      this.classList.add("open");
      document.getElementById("navigation").classList.add("open");
    }
  });
  document.getElementById("close-menu").addEventListener("click", function () {
    if (document.getElementById("burgerMenu").classList.contains("open")) {
      document.getElementById("burgerMenu").classList.remove("open");
      document.getElementById("navigation").classList.remove("open");
    }
  });
})();

function scrollW() {
  //check scroll down or up for header styles
  let st = window.pageYOffset || document.documentElement.scrollTop;
  if (st > 80) {
    if (st > lastScrollTop) {
      // downscroll code
      if (!document.getElementById("header").classList.contains("down")) {
        document.getElementById("header").classList.add("down");
        document.getElementById("header").classList.remove("up");
      }
    } else {
      // upscroll code
      if (!document.getElementById("header").classList.contains("up")) {
        document.getElementById("header").classList.add("up");
        document.getElementById("header").classList.remove("down");
      }
    }
  } else {
    if (
      document.getElementById("header").classList.contains("up") ||
      document.getElementById("header").classList.contains("down")
    ) {
      document.getElementById("header").classList.remove("up");
      document.getElementById("header").classList.remove("down");
    }
    if (
      document.getElementById("gallery") &&
      !document.getElementById("header").classList.contains("up")
    ) {
      document.getElementById("header").classList.add("up");
    }
  }
  lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function resizeWindow() {
  //calculate a new window size
  windowWidth = w.innerWidth || e.clientWidth || g.clientWidth;
  windowHeight = w.innerHeight || e.clientHeight || g.clientHeight;

  //header image to be window height on homepage
  if (document.getElementsByClassName("img-slide").length > 0) {
    let headerImages = document.getElementsByClassName("img-slide");
    let headerImagesLength = headerImages.length;
    for (let i = 0; i < headerImagesLength; i++) {
      headerImages[i].style.height = windowHeight + 10 + "px";
    }
  }
}

//animation of scroll vanilla JS
function animateTo(target) {
  var gotoTarget = offset(document.getElementById(target)).top - 100;
  var from = window.pageYOffset;
  var to = gotoTarget;
  var duration = 1300;
  var start = new Date().getTime();

  //time interval
  var timer = setInterval(function () {
    var time = new Date().getTime() - start;

    if (from <= to) {
      var yH = easeInOutQuart(time, from, to - from, duration);
    } else {
      var yH = easeInOutQuart(time, from, -(from - to), duration);
    }
    window.scrollTo(0, yH);
    if (time >= duration) clearInterval(timer);
  }, 1000 / 60);

  window.scrollTo(0, from);
}

//ease movement
function easeInOutQuart(t, b, c, d) {
  if ((t /= d / 2) < 1) return (c / 2) * t * t * t * t + b;
  return (-c / 2) * ((t -= 2) * t * t * t - 2) + b;
}

//window offset
function offset(el) {
  var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}
